import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export const isSuggestedEditsDefaultOn = (): boolean =>
	isExperimentEnabled('platform_editor_ai_suggested_edits_default_on');
